export const GET_EQUIPMENT_CATEGORIES_REQUEST = "GET_EQUIPMENT_CATEGORIES_REQUEST"
export const GET_EQUIPMENT_CATEGORIES_SUCCESS = "GET_EQUIPMENT_CATEGORIES_SUCCESS"
export const GET_EQUIPMENT_CATEGORIES_FAILURE = "GET_EQUIPMENT_CATEGORIES_FAILURE"
export const GET_NEXT_PAGE_EQUIPMENT_CATEGORIES_REQUEST = "GET_NEXT_PAGE_EQUIPMENT_CATEGORIES_REQUEST"
